/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AnalysisResultFaultDto } from './AnalysisResultFaultDto';
import {
    AnalysisResultFaultDtoFromJSON,
    AnalysisResultFaultDtoFromJSONTyped,
    AnalysisResultFaultDtoToJSON,
} from './AnalysisResultFaultDto';
import type { NumericValueDto } from './NumericValueDto';
import {
    NumericValueDtoFromJSON,
    NumericValueDtoFromJSONTyped,
    NumericValueDtoToJSON,
} from './NumericValueDto';

/**
 * 
 * @export
 * @interface TaskItemReferenceMeasurementResultsDto
 */
export interface TaskItemReferenceMeasurementResultsDto {
    /**
     * 
     * @type {Array<NumericValueDto>}
     * @memberof TaskItemReferenceMeasurementResultsDto
     */
    results?: Array<NumericValueDto> | null;
    /**
     * 
     * @type {Array<NumericValueDto>}
     * @memberof TaskItemReferenceMeasurementResultsDto
     */
    metaData?: Array<NumericValueDto> | null;
    /**
     * 
     * @type {Array<AnalysisResultFaultDto>}
     * @memberof TaskItemReferenceMeasurementResultsDto
     */
    analysisFaults?: Array<AnalysisResultFaultDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemReferenceMeasurementResultsDto
     */
    $type?: TaskItemReferenceMeasurementResultsDtoTypeEnum;
}


/**
 * @export
 */
export const TaskItemReferenceMeasurementResultsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoTaskItemReferenceMeasurementResultsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.TaskItemReferenceMeasurementResultsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TaskItemReferenceMeasurementResultsDtoTypeEnum = typeof TaskItemReferenceMeasurementResultsDtoTypeEnum[keyof typeof TaskItemReferenceMeasurementResultsDtoTypeEnum];


/**
 * Check if a given object implements the TaskItemReferenceMeasurementResultsDto interface.
 */
export function instanceOfTaskItemReferenceMeasurementResultsDto(value?: unknown): value is TaskItemReferenceMeasurementResultsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TaskItemReferenceMeasurementResultsDtoTypeEnum)[0];
}

export function TaskItemReferenceMeasurementResultsDtoFromJSON(json: any): TaskItemReferenceMeasurementResultsDto {
    return TaskItemReferenceMeasurementResultsDtoFromJSONTyped(json, false);
}

export function TaskItemReferenceMeasurementResultsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskItemReferenceMeasurementResultsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(NumericValueDtoFromJSON)),
        'metaData': !exists(json, 'metaData') ? undefined : (json['metaData'] === null ? null : (json['metaData'] as Array<any>).map(NumericValueDtoFromJSON)),
        'analysisFaults': !exists(json, 'analysisFaults') ? undefined : (json['analysisFaults'] === null ? null : (json['analysisFaults'] as Array<any>).map(AnalysisResultFaultDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TaskItemReferenceMeasurementResultsDtoToJSON(value?: TaskItemReferenceMeasurementResultsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(NumericValueDtoToJSON)),
        'metaData': value.metaData === undefined ? undefined : (value.metaData === null ? null : (value.metaData as Array<any>).map(NumericValueDtoToJSON)),
        'analysisFaults': value.analysisFaults === undefined ? undefined : (value.analysisFaults === null ? null : (value.analysisFaults as Array<any>).map(AnalysisResultFaultDtoToJSON)),
        '$type': value.$type,
    });
}

